import { render, staticRenderFns } from "./ChildProductsByDetail.vue?vue&type=template&id=4e246fc2&"
import script from "./ChildProductsByDetail.vue?vue&type=script&lang=js&"
export * from "./ChildProductsByDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChildProductsByDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports